import SlSquareStencil from './SlSquareStencil';
import OvalStencil from './OvalStencil';
import SlCircleStencil from './SlCircleStencil';
import ClosedArchStencil from './ClosedArchStencil';
import HexagonStencil from './HexagonStencil';
import StarStencil from './StarStencil';
import HeartStencil from './HeartStencil';

export {
  SlSquareStencil,
  SlCircleStencil,
  OvalStencil,
  ClosedArchStencil,
  HexagonStencil,
  StarStencil,
  HeartStencil,
};
